/* eslint-disable operator-linebreak */
import axios from 'axios'
import React, { useState, useEffect } from 'react'
import useSWR from '../../../hooks/useSWR'
import useQuery from '../../../hooks/useQuery'


import { swalError, swalSuccess, swalChoose } from '../../../common/components/Swaler'

const Controllers = () => {
  const query = useQuery()
  const choosenController = query.get('qlocxid')
  const [search, setSearch] = useState(choosenController || '')

  const { data, error } = useSWR(search.length === 8 && `/subject/admin/controllers`, {search}, { errorRetryCount: 0 })
 
  useEffect(() => {
    if (error) {
      swalError('Fel', error.message)
    }
  }, [error])

  const dereferenceController = async (_id, lockName, lockId) => {
    swalChoose('Säker?', `Vill du verkligen koppla bort ${data.public_key.slice(0, 8)} från ${lockName}?`, ['Ja', 'Avbryt']).then((r) => {
      if (r.dismiss) return

      axios
        .put(`/subject/admin/controllers/${_id}/dereference?lockId=${lockId}`)
        .then(() => {
          swalSuccess('Controller bortkopplad', '', 'OK')
          setSearch('')
        })
        .catch((e) => {
          swalError('Fel', e.message)
        })
    })
  }

  return (
    <div>
      <br />
      <input
        type="text"
        placeholder="Skriv in QlocxId"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value)
        }}
      />
      {data && data.locks?.length === 0 && <div style={{ marginTop: '10px' }}>Inget lås kopplat till controller {data.public_key.slice(0, 8)}</div>}
      {data &&
        data.locks?.map((lock) => (
          <div key={lock._id} className="flex" style={{ justifyContent: 'start' }}>
            <br />
            <div key={lock._id} style={{ background: '#fff', cursor: 'pointer', marginTop: '10px', padding: '5px' }}>
              {`QlocxId: ${data.public_key.slice(0, 8)} Projekt: ${lock.custom_name}`}
            </div>
            <span>
              <button onClick={() => dereferenceController(data._id, lock.custom_name, lock._id)} style={{ background: 'red', marginTop: '10px', marginLeft: '10px' }}>
                Koppla bort controller från projekt
              </button>
            </span>
          </div>
        ))}
    </div>
  )
}

export default Controllers
